import i18n from 'i18next'
import enUsTrans from '@/locales/en_US.json'
import zhCnTrans from '@/locales/zh_CN.json'
import { initReactI18next } from 'react-i18next'
const lang = localStorage.getItem('lang')
i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: enUsTrans,
            },
            zh: {
                translation: zhCnTrans,
            },
        },
        //默认语言
        fallbackLng: lang || 'zh',
        debug: false,
        interpolation: {
            escapeValue: false,
        },
    })


export default i18n